export const cnpjMask = {
  mask: '00.000.000/0000-00',
  regex: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/,
};
